/**
 * Handles Emergent Auth callback. Reads session_id from URL fragment, exchanges it with the
 * backend, then navigates to /desk.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || '';
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            navigate('/', { replace: true });
            return;
        }

        (async () => {
            try {
                await api.post(
                    '/auth/session',
                    {},
                    { headers: { 'X-Session-ID': sessionId }, withCredentials: true },
                );
                await refresh();
                // Clear the fragment before navigating.
                window.history.replaceState({}, document.title, window.location.pathname);
                navigate('/desk', { replace: true });
            } catch (e) {
                navigate('/', { replace: true });
            }
        })();
    }, [navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="glass-strong rounded-2xl px-8 py-6 flex items-center gap-3">
                <Loader2 className="w-4 h-4 text-lab-blue animate-spin" />
                <span className="lab-mono text-xs text-white">Verifying credentials…</span>
            </div>
        </div>
    );
}
